import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

import { playerSwipe } from "../../../utils/ModalFunc";
import RightLeftChecker from "../../../utils/RightLeftChecker";
import { getPlayerState } from "../../../redux/features/playerSlice";

const NextPrevTitle = ({ data, urlLink, topicMode, isLoading, trigger }) => {
  const navigate = useNavigate();
  const nextTopic = topicMode ? data?.next_topic : data?.next_converse;
  const prevTopic = topicMode ? data?.previous_topic : data?.previous_converse;
  const { playedPercent } = useSelector(getPlayerState);
  const [top, setTop] = useState(false);
  const [bottom, setBottom] = useState(false);
  const [firstRender, setFirstRender] = useState(false);

  useEffect(() => {
    if (data) {
      playerSwipe(top, bottom, setTop, setBottom, setFirstRender);
    }
  }, [bottom, data, top]);

  useEffect(() => {
    if (firstRender) {
      navigate(nextTopic && urlLink + nextTopic.pk, { replace: true });
      trigger({ time_watched: playedPercent * data?.duration });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [top, firstRender]);

  useEffect(() => {
    if (firstRender) {
      navigate(prevTopic && urlLink + prevTopic.pk, { replace: true });
      trigger({ time_watched: playedPercent * data?.duration });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bottom, firstRender]);

  return (
    <>
      {prevTopic && (
        <motion.div
          whileHover={{ scale: 1.04 }}
          onClick={() => navigate(urlLink + prevTopic.pk, { replace: true })}
          style={{
            position: "fixed",
            textAlign: "center",
            backgroundColor: "#FAFAFA",
            borderRadius: " 0 0 16px 16px",
            cursor: "pointer",
            opacity: 0.8,
            top: -8,
            right: 72,
            left: 72,
            height: 32,
            zIndex: 3,
            marginTop: "8px",
          }}
        >
          <Typography
            noWrap
            style={{
              fontSize: 12,
              fontWeight: 600,
              marginTop: 8,
              color: "#212121",
              paddingRight: "4px",
              paddingLeft: "4px",
              direction: RightLeftChecker(prevTopic?.title) ? "rtl" : "ltr",
            }}
          >
            {prevTopic?.title}
          </Typography>
        </motion.div>
      )}
      {nextTopic && (
        <motion.div
          whileHover={{ scale: 1.04 }}
          onClick={() => navigate(urlLink + nextTopic.pk, { replace: true })}
          style={{
            position: "fixed",
            textAlign: "center",
            backgroundColor: "#FAFAFA",
            borderRadius: "16px 16px 0 0",
            cursor: "pointer",
            opacity: 0.8,
            bottom: -8,
            right: 18,
            left: 18,
            height: 32,
            zIndex: 3,
            marginBottom: "8px",
          }}
        >
          <Typography
            noWrap
            style={{
              fontSize: 12,
              fontWeight: 600,
              marginTop: 6,
              color: "#212121",
              paddingRight: "4px",
              paddingLeft: "4px",
              direction: RightLeftChecker(prevTopic?.title) ? "rtl" : "ltr",
            }}
          >
            {nextTopic?.title}
          </Typography>
        </motion.div>
      )}
    </>
  );
};

export default NextPrevTitle;
